<script>
import Layout from "../../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Select from "@/components/c-select";
import Button from "@/components/c-button";
import Input from "@/components/c-input";
import moment from 'moment'
import { incomeExpenseReportService } from "../../../../services/reportservice/incomeexpensereport.service.js";


/* eslint-disable no-console */
export default {
  page: {
    title: "Expense Report",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { 
    Layout, 
    PageHeader, 
    Button,
    Select, 
    Input
  },
  data() {
    return {
      title: "Expense Report",
      data: [],
      date: '',
      projects: {},
      projectExpense: [],
      projectName: 'លំនៅឋាន អេច សែនសុខ (RHSS)',
      user: JSON.parse(localStorage.getItem('user')),

      dataProjectId: 0,
      s_date: '',
      e_date: '',
      supplier: '',
    };
  },
  mounted() {
    //this.loadingData(this.$route.params.id);
    this.loadingData();
    
  },
  methods: {
    
    loadingData: function() {
      this.fetchingStats = false;
      incomeExpenseReportService.getExpenseDaily()
        .then(response => {
            this.fetchingStats = true;
            this.data = response.data.result;
            console.log(this.data);
            this.date = response.data.date;
            this.s_date = response.data.date.s_date;
            this.e_date = response.data.date.e_date;
            this.dataDate = response.data.date;
            this.projects = response.data.projects;
            this.projectExpense = response.data.smmary;
            this.projecttName = response.data.project_name;
        });
    },
   
    submitSearch: function() {
      let param = '?project_id='+this.dataProjectId+
        '&s_date='+this.s_date + 
        '&e_date='+this.e_date + 
        '&supplier='+this.supplier;
        
      incomeExpenseReportService.getExpenseDaily(param)
        .then(response => {
            this.data = response.data.result;
            this.date = response.data.date;
            this.s_date = response.data.date.s_date;
            this.e_date = response.data.date.e_date;
            this.projectExpense = response.data.smmary;
            this.projectName = response.data.project_name.name +'('+response.data.project_name.name_en+')';
      });
    },
    dateFormat: function(value){
      return moment(String(value)).format('DD/MM/YYYY');
    },
    discountPrice(price, discount, dis_type) {
        let total = 0;
        if(dis_type==1){
          total = price * discount / 100;
        }else{
          total = discount
        }
        return total
    },
    formatCurrency(value) {
      if(value == 0 ){
        return 0;
      }
      let sign = '$';
      let decimal = '.00';
      return this.$options.filters.numFormat(value, `${sign}0,0${decimal}`);

      // return value;
    },
    numberFormat(value) {
      if(!value){
        return '';
      }
      let sign = '';
      let decimal = '.00';
      return this.$options.filters.numFormat(value, `${sign}0,0${decimal}`);

      // return value;
    },
    print() {
      window.print();
    },
    total(column) {
      return this.data.reduce(function (sum, item) {
        return sum + item[column];
      }, 0)
    },
    totalSummary(column) {
      return this.projectExpense.reduce(function (sum, item) {
        return sum + item[column];
      }, 0)
    },
  }
};

</script>

<template>
  <Layout>
    <PageHeader @click="print()" :add="{icon: 'bx bx-printer', title: 'general.print'}" :title="$t('report.text')+$t('report.income_expense.daily_expense')" />
      <div id="print-area">
        <!-- <center> -->
          <div class="row search-area">
            <div class="col-sm-2">
                  <Input 
                    :type="'text'"
                    :id="'supplier'"
                    v-model="supplier"
                    :label="'general.supplier'"
                    @enter="submitSearch()"
                      /> 
              </div>
              <div class="col-sm-2">
                <label>{{$t('project.text')}}</label>
                <Select
                    :id="'id'"
                    :text="'name'"
                    :editable="true"
                    :list="{data: this.projects}"
                    v-model="dataProjectId"
                    /> 
                </div>
                <div class="col-sm-2">
                    <label>{{$t('general.start-date')}}</label>
                    <Input 
                    :type="'date'"
                    :id="'start_date'"
                    v-model="s_date"
                    /> 
                </div>
                <div class="col-sm-2">
                    <label>{{$t('general.end-date')}}</label>
                    <Input 
                    :type="'date'"
                    :id="'end_date'"
                    v-model="e_date"
                    /> 
                </div>
              <div class="col-sm-2">
                <label class="text-white">{{$t('report.text')}}</label>
                <Button v-bind:icon="'bx bx-search'"
                  @click="submitSearch()" 
                  v-bind:buttonType="'button'"
                  v-bind:variant="'primary'"
                  v-bind:title="$t('general.search')" 
                />
              </div>
          </div>
          <div class="col dblack box-a4l">
            <table width="100%" class="content-general bottom">
              <tr>
                <td width="9%"><p>&nbsp;</p></td>
                <td width="50%"><p>&nbsp;</p></td>
                <td width="35%"><p>&nbsp;</p></td>
              </tr>
              <tr>
                <td><img src="@/assets/images/h-logo.svg" alt width="80" /></td>
                <td>
                  <p class="khb h4"><b>ក្រុមហ៊ុនលំនៅឋាន<span class="g-color"> អេចស៊ី </span>ឯ.ក</b></p>
                  <p class="enb h5"><b>LOMNOV THAN <span class="g-color">HC</span> CO., LTD</b></p>
                  <p class="khs h8">អាសយដ្ឋានដីឡូតិ៍លេខៈ ៧៤២ ផ្លូវលេខៈ ១៩៥២ ភូមិបាយ៉ាប សង្កាត់ភ្នំពេញថ្មី ខណ្ឌសែនសុខ រាជធានីភ្នំពេញ</p>
                  <p class="khs h8">ទូរស័ព្ទលេខៈ 092 685 009 | 098 685 009 Email: account@h-residence.net</p>
                </td>
                <td class="">
                    <h4 class="khb"><u>{{$t('report.text')+$t('report.income_expense.daily_expense')}}</u></h4>
                    <!-- <p class="khb"><u>គម្រោង: {{this.projectName}}</u></p> -->
                    <p class="khb"><u>កាលរិច្ឆេទ: {{this.dateFormat(this.s_date)}} - {{this.dateFormat(this.e_date)}}</u></p>
                </td>
              </tr>
              
            </table>
            <br/>
            <table class="content-general h8 project-sumary-table report-table" width="100%">
              
                <tr class="thead">
                  <th>{{$t('general.number')}}</th>
                  <th>{{$t('project.text')}}</th>
                  <th>{{$t('report.income_expense.date')}}</th>
                  <th>{{$t('supplier.text')}}</th>
                  <th>{{$t('expense.ref_no')}}</th>
                  <th>{{$t('report.income_expense.description')}}</th>
                   <th>{{$t('general.payment_voucher')}}</th>
                  <th>{{$t('general.aba8007')}}</th>
                  <th>{{$t('general.aba8006')}}</th>
                  <th>{{$t('general.acleda347')}}</th>
                  <th>{{$t('general.checque_number')}}</th>
                </tr>
               
                <tbody>
                    <tr v-for="(list, index) in data" :key="index" >
                        <td>{{index + 1}}</td>
                        <td>{{list.project_name_en}}</td>
                        <td>{{dateFormat(list.for_date)}}</td>
                        <td>{{list.supplier_name}}</td>
                        <td>{{list.code}}</td>
                        <td>{{list.description}}</td>
                        <td>{{formatCurrency(list.payment_voucher)}}</td>
                        <td>{{formatCurrency(list.amount_700)}}</td>
                        <td>{{formatCurrency(list.amount_800)}}</td>
                        <td>{{formatCurrency(list.amount_acleda347)}}</td>
                        <td><p> </p></td>
                    </tr>
                </tbody>
                    <tr class="tfoot" v-if="data">
                        <td colspan="6" class="text-end pe-2">{{$t('report.total')}}</td>
                        <td class="text-center border-start border-dark ps-2">{{formatCurrency(total('payment_voucher'))}}</td>
                        <td class="text-center border-start border-dark ps-2">{{formatCurrency(total('amount_700'))}}</td>
                        <td class="text-center border-start border-dark ps-2">{{formatCurrency(total('amount_800'))}}</td>
                        <td class="text-center border-start border-dark ps-2">{{formatCurrency(total('amount_acleda347'))}}</td>
                        <td></td>
                    </tr>
            </table>
            <br>
            <table class="content-general h8 project-sumary-table report-table" width="30%">
                
                    <tr class="thead">
                    <th rowspan="2">{{$t('general.number')}}</th>
                    <th rowspan="2">{{$t('report.income_expense.expense_by_project')}}</th>
                    <th rowspan="2">{{$t('report.income_expense.total_expense')}}</th>
                    </tr>
                
                <tbody>
                    <tr v-for="(list, index) in projectExpense" :key="index">
                        <td>{{index+1}}</td>
                        <td>{{list.project_name_en}}</td>
                        <td>{{formatCurrency(list.total)}}</td>
                    </tr>
                    
                    <tr>
                        <td colspan="2">{{$t('report.total')}}</td>
                        <td>{{formatCurrency(totalSummary('total'))}}</td>
                    </tr>
                </tbody>
              
            </table>
       
            <div class="row mt-3 report-table">
              <div class="col">
                <center>
                  <p class="mt-4">បានពិនិត្យនិងឯកភាព<br>នាយកផ្នែកហិរញ្ញវត្ថុ</p>
                  <p class="mt-5">លឹម ទ្រី</p>
                  <p>ថ្ងៃខែឆ្នាំ...........................</p>
                </center>
              </div>
              <div class="col">
                <center>
                  <p class="mt-4">ត្រួតពិនិត្យដោយ<br>ប្រធានគ្រប់គ្រងទូទៅ</p>
                  <p class="mt-5"></p>
                  <p>ថ្ងៃខែឆ្នាំ...........................</p>

                </center>
              </div>
              <div class="col">
                <center>
                  <p class="mt-4">ត្រួតពិនិត្យដោយ<br>ប្រធានគណនេយ្យ</p>
                  <p class="mt-5"></p>
                  <p>ថ្ងៃខែឆ្នាំ...........................</p>

                </center>
              </div>

              <div class="col">
                <center>
                  <p class="mt-4">កត់ត្រាដោយ<br>គណនេយ្យករ</p>
                   <p class="mt-5">{{this.user.name}}</p>
                  <p>ថ្ងៃខែឆ្នាំ...........................</p>

                </center>
              </div>
             
            </div>
          </div>  
        <!-- </center> -->
      </div>
    <!-- end row -->
  </Layout>
</template>